// A safety boundary, not a classifier of collectability. A young enthusiast car may
// opt in; reaching a birthday never creates a rarity premium or a sale probability.
export function requiresSpecialistReview(year, referenceYear = new Date().getFullYear()) {
  if (year == null || year === '') return false
  const y = Number(year)
  return Number.isInteger(y) && y >= 1886 && y <= referenceYear && referenceYear - y > 25
}

export const SCENARIO_FIELDS = [
  'exitPrice', 'importCosts', 'repairs', 'sellingCosts', 'monthlyHolding', 'months', 'requiredProfit',
]

/** User assumptions only. Never infer a repair reserve, tax amount or resale value. */
export function specialistScenario(values) {
  const clean = {}
  for (const field of SCENARIO_FIELDS) {
    const raw = values[field]
    if (raw == null || String(raw).trim() === '') return null
    const value = Number(raw)
    if (!Number.isFinite(value) || value < 0 || value > (field === 'months' ? 120 : 1e9)) return null
    clean[field] = value
  }
  if (clean.exitPrice <= 0) return null
  const beforeHolding = clean.exitPrice - clean.importCosts - clean.repairs - clean.sellingCosts - clean.requiredProfit
  const atMonths = months => beforeHolding - clean.monthlyHolding * months
  return {
    assumptions: clean,
    maximumBid: atMonths(clean.months),
    holdingCost: clean.monthlyHolding * clean.months,
    points: [...new Set([1, 3, 6, 12, clean.months])].sort((a, b) => a - b)
      .map(months => ({ months, maximumBid: atMonths(months) })),
  }
}
